// BrimLight/client/helpers/video-editor/ProjectSettingsFormConfig.js
import ProjectSettingsSchema from "../../../schemas/collections/projectSettings.js";
import { VoiceSelector } from "../../components/VoiceSelector.js";

export function getProjectSettingsFormConfig() {
    return {
        schema: ProjectSettingsSchema,
        layout: 'standard',
        containerClass: '',
        // REMOVED hideHeader and actions from here
        fields: {
            aspectRatio: {
                type: 'select', label: 'Aspect Ratio',
                options: [
                    { value: '16:9', label: '16:9 (Widescreen)' },
                    { value: '9:16', label: '9:16 (Vertical)' },
                    { value: '1:1', label: '1:1 (Square)' }
                ]
            },
            videoStyle: {
                type: 'select', label: 'Video Style',
                options: [
                    'cinematic_realistic', 'pixar_animation', 'ghibli_style', 'anime_90s', 'claymation', 
                    'stop_motion', 'watercolor_painting', 'oil_painting', 'charcoal_sketch', 'pencil_drawing', 
                    'comic_book', 'graphic_novel', 'low_poly_3d', 'vaporwave', 'cyberpunk', 'steampunk', 
                    'fantasy_art', 'sci_fi_concept_art', 'vintage_film', 'noir_film', 'documentary', 'isometric'
                ].map(style => ({ value: style, label: style.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) }))
            },
            narratorVoice: {
                type: 'VoiceSelector', label: 'Narrator Voice', component: VoiceSelector
            },
            defaultImageEffect: {
                type: 'select', label: 'Default Image Effect',
                options: [
                    'static', 'slow_zoom_in', 'slow_zoom_out', 'pan_left', 'pan_right', 'pan_up', 'pan_down', 
                    'dolly_zoom', 'gentle_rotation_cw', 'gentle_rotation_ccw', 'shaky_cam', 'fade_in', 'fade_out'
                ].map(style => ({ value: style, label: style.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) }))
            },
            defaultTransition: {
                type: 'select', label: 'Default Transition',
                options: [
                    'cut', 'crossfade', 'dip_to_black', 'dip_to_white', 'wipe_left', 'wipe_right', 'wipe_up', 
                    'wipe_down', 'iris_circle', 'star_wipe', 'glitch', 'pixelate'
                ].map(style => ({ value: style, label: style.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) }))
            },
            defaultSceneDuration: {
                type: 'number', label: 'Default Scene Duration (seconds)'
            }
        }
    };
}
